import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useMode, MODES } from '../context/ModeContext';
import Navbar from '../pages/Navbar';
import Footer from '../pages/Footer';

function CryptoLayout() {
    const { mode, setMode, hasSelectedMode } = useMode();
    const navigate = useNavigate();

    useEffect(() => {
        // If no mode selected, redirect to mode selector
        if (!hasSelectedMode) {
            navigate('/select-mode');
            return;
        }

        // If mode is fiat, redirect to fiat
        if (mode === MODES.FIAT) {
            navigate('/fiat');
            return;
        }

        // Ensure crypto mode is set
        if (mode !== MODES.CRYPTO) {
            setMode(MODES.CRYPTO);
        }
    }, [mode, hasSelectedMode, navigate, setMode]);

    return (
        <div className="app-layout crypto-layout">
            <Navbar mode="crypto" />
            <main className="main-content">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
}

export default CryptoLayout;
